import { GetListingAddOnAvailabilityPublicEndpoint } from '@kouto/types';
import useSWR from 'swr';
import { get } from 'utils/axios';
import { convertIntervalToMinutes } from 'utils/formatDuration';
import { z } from 'zod';

interface UseListingAddOnAvailabilityProps {
  listingId?: string;
  experienceId?: string;
  startDateTime?: string;
  sessionDuration?: string;
}

const useListingAddOnAvailability = ({
  listingId,
  experienceId,
  startDateTime,
  sessionDuration,
}: UseListingAddOnAvailabilityProps) => {
  const duration = sessionDuration
    ? convertIntervalToMinutes(sessionDuration)
    : 0;
  const url =
    listingId && experienceId && startDateTime && duration > 0
      ? GetListingAddOnAvailabilityPublicEndpoint.url({
          listingId,
          query: { experienceId, startDateTime, sessionDuration: duration },
        })
      : null;

  return useSWR(
    url,
    async (requestUrl) => {
      return get<
        z.infer<typeof GetListingAddOnAvailabilityPublicEndpoint.responseSchema>
      >(requestUrl);
    },
    { revalidateOnFocus: true },
  );
};

export default useListingAddOnAvailability;
